export const GET_TENANT_LICENSE = 'GET_TENANT_LICENSE';
export const GET_ORG_LICENSES = 'GET_ORG_LICENSES';
export const LICENSES_LOADING = 'LICENSES_LOADING';
export const ORG_LICENSE_COUNT = 'ORG_LICENSE_COUNT';